<template>
    <div class="card">
        <div class="card-body py-3">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                    <div class="text-muted small mb-1">{{ title }}</div>
                    <div v-if="loading" class="spinner-border spinner-border-sm text-secondary" role="status">
                        <span class="visually-hidden">Cargando...</span>
                    </div>
                    <div v-else class="fs-3 fw-bold" :class="`text-${variant}`">{{ value }}</div>
                </div>
                <i v-if="icon" :class="`bi ${icon} fs-2 opacity-25`" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
    title: string
    value: number | string
    icon?: string
    variant?: string
    loading?: boolean
}>(), {
    variant: 'secondary',
    loading: false,
})
</script>
